/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./HomepageMenuCn.css";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

class HomepageMenuCn extends Component {
  render() {
    return (
      <div className="HomepageMenuCn-main">
        <div className="HomepageMenuCn-leftContainer">
          <div className="HomepageMenuCn-outsideHeader">
            <div className="HomepageMenuCn-navBar">
              <div
                className="HomepageMenuCn-menuBtn"
                onClick={() => this.props.closeModal()}
              >
                <div className="HomepageMenuCn-menuIcn" />
              </div>

              <div
                className="HomepageMenuCn-CheckPlusLogo"
                onClick={() => this.props.closeModal()}
              />

              <div className="HomepageMenuCn-navBarContainer">
                <Link to="/En">
                  <div className="HomepageMenuCn-settingsContainer">
                    <div className="HomepageMenuCn-settingsTxt">概览</div>
                  </div>
                </Link>

                <Link to="/EnWhyCheckPlus">
                  <div className="HomepageMenuCn-settingsContainer">
                    <div className="HomepageMenuCn-settingsTxt">
                      为什么选择 CheckPlus？
                    </div>
                  </div>
                </Link>
                <Link to="/EnSecurity">
                  <div className="HomepageMenuCn-settingsContainer">
                    <div className="HomepageMenuCn-settingsTxt">系统安全</div>
                  </div>
                </Link>
                <Link to="/EnPricing">
                  <div className="HomepageMenuCn-settingsContainer">
                    <div className="HomepageMenuCn-settingsTxt">费用</div>
                  </div>
                </Link>
                <Link to="/CnFaq">
                  <div className="HomepageMenuCn-settingsContainer">
                    <div className="HomepageMenuCn-settingsTxt">常见问题</div>
                  </div>
                </Link>
                <Link to="/OrgLogin">
                  <div className="HomepageMenuCn-logoutContainer">
                    <div className="HomepageMenuCn-logoutTxt">机构登入</div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="HomepageMenuCn-bg" />
      </div>
    );
  }
}

HomepageMenuCn.propTypes = {
  show: PropTypes.bool,
  closeModal: PropTypes.func,
  state: PropTypes.object,
};

export default HomepageMenuCn;
